import React, { useEffect, useState } from 'react'
import Table from './MainTable'
import { useGetInfogaphicsListQuery } from '../../components/Store/Features/SitemapAPI'
import Link from 'next/link'
import Heading from '../Common/SectionHeading'
import { useRouter } from "next/router";

export default function SamplePages() {

    const router = useRouter();

    const { slug } = router.query;

    const { data: posts, isError, isLoading } = useGetInfogaphicsListQuery('/data/category/' + slug);
    const [Reports, setReports] = useState([])

    useEffect(() => {
        if (isLoading === false) {
            setReports(posts?.data);
        }
    }, [posts, isLoading])

    const tableColumns = [
        { header: 'Product Name', field: 'name' },
    ];

    const customButton = (slug) => {
        return (
            <>
                <div className="flex justify-start">
                    <Link href={process.env.APP_URL + "/report-store/" + slug}>
                        <button className="bg-[#27a827] ml-3 text-white font-semibold py-2 px-4 rounded">
                            Visit Report
                        </button>
                    </Link>

                    <Link href={process.env.APP_URL + "/sample-request/" + slug}>
                        <button className="bg-[#1e5df3] ml-3 text-white font-semibold py-2 px-4 rounded">
                            Visit Sample Page
                        </button>
                    </Link>
                </div>
            </>
        )
    }

    return (
        <>
            <div className='my-10'>
                <h1 className='text-center text-[20px] font-semibold'>ALL Reports and Sample Pages</h1>
                <Table customButton={customButton} tableColumns={tableColumns} data={Reports} search={['name']} />
            </div>
        </>
    )
}
